module.exports = __webpack_public_path__ + "static/media/trading.d7a9ec9d.png";